import { useTranslation } from 'react-i18next';

export const BeforeYouStart = () => {
  const { t } = useTranslation('pages.openEnrollment');
  return (
    <main data-testid="enrollment-before-you-start-section" id="mainContent">
      <h1 className="my-4 primary-content">{t('oe.before')}</h1>
      <div className="row">
        <div className="col-auto">
          <i
            className="ph ph-files font-36"
            aria-hidden="true"
            role="presentation"
          ></i>
        </div>
        <div className="col">
          <h2>{t('oe.prepare')}</h2>
          <p>{t('oe.prepDesc')}</p>
        </div>
      </div>
      <div className="row mt-md-4">
        <div className="col-auto">
          <i
            className="ph ph-clock-countdown font-36"
            aria-hidden="true"
            role="presentation"
          ></i>
        </div>
        <div className="col">
          <h2>{t('oe.time')}</h2>
          <p>{t('oe.timeDesc')}</p>
        </div>
      </div>
      <div className="row mt-md-4">
        <div className="col-auto">
          <i
            className="ph ph-shield-check font-36"
            aria-hidden="true"
            role="presentation"
          ></i>
        </div>
        <div className="col">
          <h2>{t('oe.just')}</h2>
          <p>{t('oe.justDesc')}</p>
        </div>
      </div>
    </main>
  );
};
